/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure additional models available to this team beyond the organization's base models." |
*
* @param {Team_Models_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_dialog_description = /** @type {((inputs?: Team_Models_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie zusätzliche Modelle, die diesem Team über die Basismodelle der Organisation hinaus zur Verfügung stehen.")
	return /** @type {LocalizedString} */ ("Configure additional models available to this team beyond the organization's base models.")
});